import { render } from "./x9_footer.vue?vue&type=template&id=2c44c56e&scoped=true"
import script from "./x9_footer.vue?vue&type=script&lang=js"
export * from "./x9_footer.vue?vue&type=script&lang=js"

import "./x9_footer.vue?vue&type=style&index=0&id=2c44c56e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c44c56e"]])

export default __exports__